import { useContext, useEffect, useState } from "react";
import { TTaskData } from "../types/task";
import { HomeContext } from "../containers/Home";
import { TProjectData } from "../types/project";
import {
	checkProjectTeam,
	checkSuperAdminPriviledge,
	includesIgnoreCase,
} from "../utils/utils";

function useDragTaskCard() {
	const { userInfo, userRole }: any = useContext(HomeContext);

	const [active, setActive] = useState(false);

	const isCardDraggable = (project: TProjectData, task: TTaskData) => {
		if (task?.closed) {
			const responsibleParty = project?.role_assignments.filter((role: any) =>
				task.responsible_roles.includes(role.role_id)
			);

			return (
				userRole.role === "tenant_admin" ||
				checkSuperAdminPriviledge(userInfo.userRole) ||
				checkProjectTeam(userInfo.user.email, responsibleParty) ||
				includesIgnoreCase(project?.project_manager, userInfo.user.email)
			);
		}
		return true;
	};

	const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
		const task = JSON.parse(e.dataTransfer.getData("task"));
		setActive(false);
		return task;

		// // remove the card from the previous column and add it to this column
		// let copy = [...cards];
		// let card = copy.find((card: any) => card._id === cardId);

		// if (!card || textHighlight) {
		// 	setActive(false);
		// 	return;
		// }

		// if (context.currentProject && column.status == "Closed") {
		// 	const _responsibleParty = context.currentProject?.role_assignments.filter(
		// 		(role: any) => card.responsible_roles.includes(role.role_id)
		// 	);

		// 	if (
		// 		!(
		// 			context?.userRole.role === "tenant_admin" ||
		// 			checkSuperAdminPriviledge(context.userInfo.userRole) ||
		// 			checkProjectTeam(context.userInfo.user.email, _responsibleParty) ||
		// 			//check if the user is in the project manager case-sensitive, project_manager is an array of string must be case sensitive
		// 			includesIgnoreCase(
		// 				context.currentProject?.project_manager,
		// 				context.userInfo.user.email
		// 			)
		// 		)
		// 	) {
		// 		setActive(false);
		// 		setActiveKey(cardId);
		// 		return;
		// 	}
		// }
		// if (column.status !== "Closed" && card.closed === true) {
		// 	setActiveCard(card);
		// 	setReopenModalOpen(true);
		// 	setActive(false);
		// 	setActiveKey(cardId);
		// 	return;
		// }
		// if (column.status === "Closed" && card.closed !== true) {
		// 	setActiveCard(card);
		// 	setConfirmCloseTaskModalOpen(true);
		// 	setActive(false);
		// 	setActiveKey(cardId);
		// 	return;
		// }
		// if (column.status === "Late" && card.status !== "Late") {
		// 	setBlockedModalOpen(true);
		// 	setActive(false);
		// 	setActiveKey(cardId);
		// 	return;
		// }

		// if (column.status === card.status) {
		// 	setActive(false);
		// 	return;
		// }
		// let newCard = { ...card, status: column.status };
		// setActive(false);
		// if (newCard.status !== "Late") {
		// 	newCard.blocker = null;
		// 	newCard.plan = null;
		// }
		// // update the card status in frontend
		// setCards(
		// 	copy
		// 		.filter((c: any) => c._id !== cardId)
		// 		.concat(newCard)
		// 		.sort((a: any, b: any) => {
		// 			if ("sequence_id" in a && "sequence_id" in b) {
		// 				if (a.sequence_id && b.sequence_id) {
		// 					return b.sequence_id - a.sequence_id;
		// 				}
		// 				return 0;
		// 			}
		// 			return 0;
		// 		})
		// );
		// updateCardStatus(cardId, newCard, card); // update the card status in the backend
	};

	const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		setActive(true);
	};

	const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		setActive(false);
	};

	return {
		isCardDraggable,
		handleDrop,
		handleDragOver,
		handleDragLeave,
		active,
	};
}

export default useDragTaskCard;
